import React, { Component } from 'react'
import Ear from 'material-ui/svg-icons/av/hearing'
import Video from 'material-ui/svg-icons/av/video-call'
import ReactTooltip from 'react-tooltip'
import { checkJapanese } from '../../lib/lib'

export default class TableActions extends Component {
  state = {
    listenActive: this.props.hear,
    videoActive: false
  }
  handleClick = (e, purpose) => {
    if (purpose === 'listen') {
      this.props.onHear(this.props.group, !this.props.hear)
    } else {
      this.props.joinVideo(this.props.user_uid, this.props.user_name, this.props.group, this.props.user_id, this.props.user_role, this.props.direct)
    }
  }

  render () {
    return (
      <div className={'w-100 h-100'}>
        <ReactTooltip
          place='top'
          multiline
          effect='solid'
          html/>
        <div
          data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    テーブルの音声を聞く
                    ` : `
                    hear the table discussion
                  `}
                </div>`}
          onClick={(e) => this.handleClick(e, 'listen')}
          className='w-50 h-100 fl flex justify-center items-center pointer'
          style={{
            borderRight: '1px solid #2282d9',
            backgroundColor: (this.state.listenActive) ? '#1B7ED8' : 'inherit'
          }}>
          <Ear
            className='mt3 ml3'
            style={{
              height: 35,
              width: 30,
              fill: (this.state.listenActive) ? '#FFFFFF' : '#0B61AF'
            }}/>
        </div>
        <ReactTooltip
          place='top'
          multiline
          effect='solid'
          html/>
        <div
          data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    テーブルに入る
                    ` : `
                    Join this table
                  `}
                </div>`}
          onClick={(e) => this.handleClick(e, 'video')}
          style={{
            borderLeft: '1px solid #2282d9',
            backgroundColor: (this.state.videoActive) ? '#1B7ED8' : 'inherit'
          }}
          className='w-50 h-100 fl flex justify-center items-center pointer'>
          <Video
            className='mt3 mr3'
            style={{
              height: 35,
              width: 30,
              fill: (this.state.videoActive) ? '#FFFFFF' : '#0B61AF'
            }}/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/TableActions.js